import styled from "styled-components";
import { Link } from "react-router-dom";
import { EyeIcon } from "../../../assets/svg/Form/FormSvg";


export const FormContainerAdminSignUp = styled.div`
@import url('https://fonts.googleapis.com/css2?family=DM+Sans&display=swap');

font-family: 'DM Sans', sans-serif;
background-color: white;
display: grid;
height: 100%;
place-items: center;
padding: 0.5em 3em 2.5em 3em;

img{
    width: 5.63em;
    height: 5.63em;

}


&>svg:nth-child(1){
    position: fixed;
    width: 54.98em;
    height: 32.25em;
    left: -1.49em;
    top: -2.39em;
}

&>svg:nth-child(2){
    position: fixed;
    width: 39.66em;
    height: 39.66em;
    left: 39.15em;
    top: 5.74em;
}



@media(max-width:555.33px){
        width: 92.4%;
    }
    @media(max-width:490px){
        width: max-content;
    }

    @media(max-width:479px){
        padding-bottom: 3.5em;
    }

    @media(max-width:463.33px){
        padding-bottom: 5em;
    } 

    @media(max-width:454.33px){
        padding-bottom: 6.5em;
    } 

    @media(max-width:438.33px){
        padding-bottom: 8em;
    }

    @media(max-width:422.33px){
        padding-bottom: 9.5em;
    }

    @media(max-width:411.33px){
        padding-bottom: 11em;
    }

    @media(max-width:399.33px){
        padding-bottom: 12.5em;
    }
     
    @media(max-width:388.33px){
        padding-bottom: 14em;
    } 

    @media(max-width:377.33px){
        padding-bottom: 15.5em;
    } 

    @media(max-width:367.33px){
        padding-bottom:17em;
    } 

    @media(max-width:357.33px){
        padding-bottom:18.5em;
    } 

    @media(max-width:348.33px){
        padding-bottom:20em;
    } 

    @media(max-width:339.33px){
        padding-bottom:21.5em;
    } 

    @media(max-width:331.33px){
        padding-bottom:23em;
    } 
    @media(max-width:323.33px){
        padding-bottom:24.5em;
    }  

    @media(max-width:315.33px){
        padding-bottom:26em;
    }  

    @media(max-width:309.33px){
        padding-bottom:27.5em;
    }  

    @media(max-width:301.33px){
        padding-bottom:29em;
    }  

    @media(max-width:295.33px){
        padding-bottom:30.5em;
    }

    @media(max-width:289.33px){
        padding-bottom:32em;
    }

    @media(max-width:284.33px){
        padding-bottom:33.5em;
    }



    @media(min-height:740px){
        padding-bottom: 17.7em;
    } 

`

export const GridDiv =styled.div`
display: grid;
grid-template-rows: 1fr 6fr;
place-items: center;
`

export const FormContainerUserSignUp = styled.div`
    @import url('https://fonts.googleapis.com/css2?family=DM+Sans&display=swap');

    font-family: 'DM Sans', sans-serif;
    background-color: #16202b;
    display: grid;
    place-items: center;
    height: 100%;
    grid-template-rows: 1fr 6fr;
    img{
        width: 5.63em;
        height: 5.63em;
    }
    padding: 0.5em 3em 2.5em 3em;

    @media(max-width:555.33px){
        width: max-content;
    }

   


    @media(max-width:479px){
        padding-bottom: 3.5em;
    }

    @media(max-width:463.33px){
        padding-bottom: 5em;
    } 

    @media(max-width:454.33px){
        padding-bottom: 6.5em;
    } 

    @media(max-width:438.33px){
        padding-bottom: 8em;
    }

    @media(max-width:428.33px){
        padding: 0.5em 2em 2.5em 2em;


        &>form{
            width: 21.55em;
            padding: 1.1em 0.6em 2em 0.6em;
            display: grid;
            
            label{
                font-size: 0.8em;
                line-height: 1.8em;
            }

            &>div:nth-child(1){
                position: relative;
                left: 2.1em;
                margin-bottom: 0.8em;
                p{
                    font-size: 0.7em;
                }
                span{
                    font-size: 1.45em;
                }
            }

           
        }
    }

    @media(max-width:422.33px){
        padding: 0.5em 1.5em 9.5em 1.5em;
        &>form{
            padding: 1.1em 0.7em 2em 0.7em;
            &>div:nth-child(1){
            position: relative;
            left: 1.8em;
        }
        }

    }


    @media(max-width:411.33px){
        padding-bottom: 11em;
    }

    @media(max-width:399.33px){
        padding-bottom: 12.5em;
    }

    
    @media(max-width:390.33px){
        padding: 1.1em 1em 2em 0.8em;
    }
     

    @media(max-width:388.33px){
        padding-bottom: 14em;
    } 

    @media(max-width:377.33px){
        padding-bottom: 15.5em;
    } 

    @media(max-width:367.33px){
        
        padding: 1.1em 0.7em 17em 0.7em;
        form{
            width: 20em;
            padding: 1.1em 0.5em 2em 0.6em;

            &>div:nth-child(1){
            position: relative;
            left: 1.2em;
        }

        }
        

    } 

    @media(max-width:357.33px){
        padding-bottom:18.5em;
    } 

    @media(max-width:348.33px){
        padding-bottom:20em;
    } 

    @media(max-width:339.33px){
        padding-bottom:21.5em;
    } 

    @media(max-width:331.33px){
        padding-bottom:23em;
    } 
    @media(max-width:323.33px){
        padding: 0.5em 3em 24.5em 3em;

    }  

    @media(max-width:315.33px){
        padding-bottom:26em;
    }  

    @media(max-width:309.33px){
        padding-bottom:27.5em;
    }  

    @media(max-width:301.33px){
        padding-bottom:29em;
    }  

    @media(max-width:295.33px){
        padding-bottom:30.5em;
    }

    @media(max-width:289.33px){
        padding-bottom:32em;
    }

    @media(max-width:284.33px){
        padding-bottom:33.5em;
    }

    @media(max-width:277.33px){
        padding-bottom:35em;
    }

    @media(max-width:271.33px){
        padding-bottom:36.5em;
    }

    @media(max-width:266.33px){
        padding-bottom:38em;
    }


    @media(max-width:261.33px){
        padding-bottom:39.5em;
    }


    @media(max-width:256.33px){
        padding-bottom:41em;
    }


    @media(max-width:251.33px){
        padding-bottom:42.5em;
    }


    @media(max-width:247.33px){
        padding-bottom:44em;
    }


    @media(max-width:243.33px){
        padding-bottom:45.5em;
    }


    @media(max-width:240.33px){
        padding-bottom:47em;
    }


    /* @media(max-width:284.33px){
        padding-bottom:48.5em;
    }


    @media(max-width:284.33px){
        padding-bottom:50em;
    }


    @media(max-width:284.33px){
        padding-bottom:51.5em;
    } */



    @media(min-height:600px){
        padding-bottom: 36em;
    } 

    @media(min-height: 800px){
        padding-bottom: 43.5em;
    }

    @media(min-height: 900px){
        padding-bottom: 46em;
    }

`

export const FormTitle = styled.div`
    height: fit-content;
    margin-bottom: 1.4em;
    span{
        font-weight: 700;
        font-size: 1.5em;
        letter-spacing: -0.025em;
        color: #000000;

    }

    p{
        font-weight: 400;
        font-size: .8em;
        line-height: 0.05em;
        color: #425466;
    }
`

export const InputFlex = styled.div`
    display: flex;
    justify-content: space-between;
    margin-bottom: .8em;
    width: 100%;
    div{
        display: grid;
    }

    @media(max-width:428.33px){
        justify-self: center;
        width: 83.3%;
        input{
            width: 10em;
        }
    }

    @media(max-width:370.33px){
        width:88.3% ;
        input{
            width: 9.8em;
        }
    }

`

export const StyledInput = styled.input`
background: #FFFFFF;
border: 1px solid #E3E6E8;
border-radius: 0.5em;
height: 2.6em;
    &::-ms-reveal{
        display: ${({password}) => password ? 'none' : ''}
    }
`


export const Label = styled.label`
    font-weight: 400;
    font-size: .9em;
    line-height: 2em;
    color: #454D54;
`

export const InputGrid = styled.div`
`

export const InputDiv = styled.div`
    margin-bottom: .6em;
    width: 100%;
    display: grid;

   

    &>div{
        position: absolute;
        place-self: center;
        margin-left: 20em;
        margin-top: 1.7em;
        cursor: pointer;
        transition: 250ms;
        
    }

    svg{
        width: .94em;
        height: .63em;
    }
    
   
    @media(max-width:428.33px){
        width: 18em;
        justify-self: center;
        &>div{
            margin-left: 16.5em;
            margin-top: 1.5em;
        }
    }

`

export const FormInfo = styled.div`
    margin-top: 1.2em;
    font-weight: 400;
    font-size: 0.8em;
    line-height: 1.06em;

    
    a{
        text-decoration: none;
    }
    @media(max-width: 428.33px){
        position: relative;
        left: 2.1em;
    }

    @media(max-width: 422.33px){
        position: relative;
        left: 1.8em;
    }

    @media(max-width: 367.33px){
        position: relative;
        left: 1.2em;
    }
`
export const Details = styled.span`
    color: #353535;
`
export const FormLink = styled(Link)`
color: #377DFF;
` 

export const FormSpan = styled.p`
font-weight: 500;
font-size: .8em;
color: #0a1f44;
margin-left: 0.6em;
`


export const Flex = styled.div`
display: flex;
margin-top: 0.8em;
align-items: center;

@media(max-width: 428.33px){
    position: relative;
    left: 1.8em;
    margin-top: 0px;
}

`


export const Reveal = ({onReveal, id}) => (
    <div id={id} onClick={onReveal}><EyeIcon/></div>
)